import { css, cx } from 'linaria';
import { styled } from 'linaria/react';
import React, { useEffect } from 'react';
import ButtonWithLoading from '../ui/Button';

export function VariantSelector({
  product,
  variantHandler,
  showValidation,
  selectedSize
}) {
  return (
    <div className={sharedStyles}>
      {product.variants.options.map(option => {
        let showValidationMessage = false;
        if (
          showValidation &&
          variantHandler.getMissingOptions()?.includes(option)
        ) {
          showValidationMessage = true;
        }

        return (
          <ButtonSelect
            option={option}
            variantHandler={variantHandler}
            key={option.name}
            showValidationMessage={showValidationMessage}
            selectedSize={selectedSize}
          />
        );
      })}
    </div>
  );
}

const sharedStyles = css`
  width: 100%;
  .invalid {
    label {
      color: #eb5757;
    }
  }
  .missingVariant {
    margin-right: 0.25em;
    height: 10px;
    width: 10px;
  }
`;

function ButtonSelect({
  option,
  variantHandler,
  showValidationMessage,
  selectedSize
}) {
  const {
    getSelectedValue,
    validateSelection,
    selectValue,
    getVariantForSelection
  } = variantHandler;
  const selectedValue = getSelectedValue(option);

  useEffect(() => {
    if (selectedSize && option.values.includes(selectedSize)) {
      selectValue(selectedSize, option);
    }
  }, [option, selectValue, selectedSize]);

  return (
    <div
      className={cx(
        buttonSelectStyles,
        showValidationMessage ? 'invalid' : null
      )}
    >
      <h2>{option.name}</h2>
      <ButtonsWrapper>
        {option.values.map(value => {
          const validation = validateSelection(value, option);
          const variant = getVariantForSelection(value, option);
          return (
            <ButtonWithLoading
              data-testid={option.name + value}
              key={option.name + value}
              onClick={() => selectValue(value, option)}
              disabled={
                validation === 'invalid' || !variant?.stockStatus?.buyable
              }
              secondary={value !== selectedValue}
              aria-pressed={value === selectedValue}
              selected={value === selectedValue}
              className={cx(
                validation,
                !variant?.stockStatus?.buyable && 'outOfStock'
              )}
            >
              {value}
            </ButtonWithLoading>
          );
        })}
      </ButtonsWrapper>
    </div>
  );
}

const ButtonsWrapper = styled('div')`
  display: flex;
  justify-content: center;
  button {
    background-color: white;
    border: 1px solid #ddd;
    color: black;
    display: inline-block;
    font-size: 12px;
    font-weight: 300;
    height: 40px;
    justify-content: center;
    line-height: 36px;
    margin: 5px;
    outline: none;
    padding: 0;
    position: relative;
    text-align: center;
    transition: all ease 0.3s;
    width: 40px;
    align-items: center;
    justify-content: center;
    &[aria-pressed='true'] {
      box-shadow: 1px 1px 5px #555;
      ::after {
        border-bottom: 3px solid black;
        content: '';
        display: block;
        padding-top: 0.5rem;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        top: 100%;
      }
    }
    &:hover {
      box-shadow: 1px 1px 5px #555;
      background: white;
    }
    &.outOfStock {
      background-color: #ffc2c2;
      border: 1px solid #fb8080;
      color: rgba(0, 0, 0, 0.5);
      cursor: not-allowed;
      pointer-events: none;
    }
  }
`;

const buttonSelectStyles = css`
  margin: 1em 0;
  button {
  }
  &.invalid button {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
`;
